import React from "react";
import '../../../styles/components/onboarding/info/steps-page.scss';
import sectionIconsPNG from "./images/steps-section-icons@3x.png";
import sectionIconsWebP from "./images/steps-section-icons@3x.webp";
import {WhenDeviceTypeDesktop} from "../../conditional/device/type/WhenDeviceTypeDesktop";
import {DynamicImage} from "../../common/DynamicImage";
export default function StepsPage() {
  return (
    <div className="steps-page">
      <WhenDeviceTypeDesktop>
        <DynamicImage width={576} height={195} pngSrc={sectionIconsPNG} webpSrc={sectionIconsWebP} additionalClassName={"slide-image slide-center"} alt={"Bootcamp, Courses, and Songs"} />
      </WhenDeviceTypeDesktop>
      <WhenDeviceTypeDesktop not>
        <header className="top">
          <DynamicImage width={576} height={195} pngSrc={sectionIconsPNG} webpSrc={sectionIconsWebP} additionalClassName={"stepsImage"} alt={"Bootcamp, Courses, and Songs"}/>
        </header>
      </WhenDeviceTypeDesktop>

      <div className="content">
        <div className="content-header">Take steps on your learning&nbsp;path</div>
        <div className="info-text">Get the basics down in Bootcamp. Go deeper into specific areas in Courses. Learn all your favorites in&nbsp;Songs.</div>
      </div>
    </div>
  );
}